// The volunteer area of the client portal: the volunteer's list of assigned client files and their
// view of an opened client file. Column headers reuse clients.table.
export default {
  navigation: {
    assignedClients: "Meine Kund:innen",
  },
  assignedClients: {
    title: "Meine Kund:innen",
    subtitle_one: "{{count}} Ihnen zugewiesene:r Kund:in. Zum Öffnen eines Kundenakts auf die Zeile klicken.",
    subtitle_other: "{{count}} Ihnen zugewiesene Kund:innen. Zum Öffnen eines Kundenakts auf die Zeile klicken.",
    loadError: "Die Liste Ihrer Kund:innen konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
  },
  clientFile: {
    loadError: "Der Kundenakt konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
  },
};
